import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import SectionFadeIn from "@/components/SectionFadeIn";
import { getRouteState } from "@/lib/navigation";
import { MURAL_COLLECTIONS } from "@/lib/muralCollections";

export function MuralStyleGallery({ location }) {
  return (
    <section
      className="pt-10 pb-20 md:pt-12 md:pb-24"
      data-testid="murals-style-gallery"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <SectionFadeIn>
          <div className="flex items-end justify-between gap-6 flex-wrap">
            <div>
              <p className="text-[11px] tracking-[0.25em] uppercase font-semibold text-brand-gold mb-3">
                Browse by Style
              </p>
              <h2 className="font-heading text-3xl sm:text-4xl tracking-tight text-brand-text">
                Find Your Mural
              </h2>
              <p className="mt-2 text-[14px] text-brand-text-secondary/60 max-w-lg">
                Choose a theme to explore designs, or send us any image and we'll print it to your wall.
              </p>
            </div>
            <Link
              to="/collections/wall-murals"
              state={getRouteState(location)}
              className="text-[12px] text-brand-text-secondary hover:text-brand-gold transition-colors duration-300 tracking-wide uppercase font-medium flex items-center gap-1.5 shrink-0"
              data-testid="style-view-all"
            >
              View all designs <ArrowRight size={13} />
            </Link>
          </div>
        </SectionFadeIn>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-4">
          {MURAL_COLLECTIONS.map((col, i) => {
            const Icon = col.icon;
            return (
              <SectionFadeIn key={col.slug} delay={i * 50}>
                <Link
                  to={`/wall-murals/${col.slug}`}
                  state={getRouteState(location)}
                  className="group relative block rounded-sm overflow-hidden border border-white/[0.06] hover:border-brand-gold/30 transition-all duration-300"
                  data-testid={`style-card-${col.slug}`}
                >
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={col.image}
                      alt={col.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0A0D14]/90 via-[#0A0D14]/30 to-transparent" />
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <div className="flex items-center gap-2 text-brand-gold mb-1.5">
                      <Icon size={15} />
                    </div>
                    <h3 className="text-[14px] font-semibold text-brand-text group-hover:text-brand-gold transition-colors duration-300 leading-tight">
                      {col.title}
                    </h3>
                    <p className="mt-1 text-[11px] text-brand-text-secondary/50 line-clamp-1">
                      {col.short}
                    </p>
                  </div>
                </Link>
              </SectionFadeIn>
            );
          })}
        </div>
      </div>
    </section>
  );
}
